exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h5 {\n    font-size: medium;\n    font-weight: bold;\n    font-style: italic;\n    color: #007eb3;\n    padding: 0px;\n}\n\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/Login/login.component.css
// module id = 451
// module chunks = 1